// extracted by mini-css-extract-plugin
export default {"label":"styles_label__L0vfu","required":"styles_required__Lny1d","altLabel":"styles_altLabel__StbCH"};